import api from "@/router/api"
import store from "@/store"
import authService from "@/services/auth/authService"

export default {
	setDocumentActionLog({ commit }, payload) {
		return new Promise((resolve, reject) => {
			api.logDocument.setDocumentActionLog(payload)
				.then(response => {})
				.catch(() => {
					reject({
						message: 'Error al insertar el log.'
					})
				})
		})
	},

	downloadAllDocuments({ commit }, payload) {
		return new Promise((resolve, reject) => {
			api.logDocument.downloadAllDocuments(payload)
				.then(response => {
					const url = window.URL.createObjectURL(new Blob([response.data]))
					const link = document.createElement("a")
					link.href = url

					const zipName = `${payload.path}.zip`
					link.setAttribute("download", zipName)

					document.body.appendChild(link)
					link.click()

					link.parentNode.removeChild(link)
					window.URL.revokeObjectURL(url)

					resolve("Archivo descargado correctamente")
				})
				.catch(() => {
					reject({
						message: "Error al descargar todos los documentos.",
					})
				})
		})
	}

}
